import { LogCannon } from '@ace-clublabs/log-cannon';

export const createAxiosConfig = (scenario: string | null | undefined, endpoint: string) => {
  const headers = {
    'X-Ace-Session-Id': LogCannon.getSessionId(),
    'X-AWS-Region': sessionStorage.getItem('x-aws-region') || undefined,
    // 'x-px-block-really': '1',
  } as any;

  if (endpoint.includes('/newjoin/')) {
    headers['X-Ace-Pathname'] = window.location.pathname;
  }

  if (endpoint.search('api.ace.aaa.com') > -1) {
    return {
      headers,
    };
  }
  return {
    headers: {
      ...headers,
      'X-Ace-Mock': scenario ? 'true' : 'false',
      'X-Ace-Test-Scenario': scenario ? scenario : undefined,
    },
  };
};
